import React, { memo } from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import moment from 'moment';
import isNil from 'ramda/src/isNil';
import Accordion from '@components/@core/Accordion';
import Button from '@components/@core/AnimatedButton';
import Input from '@components/@core/Input';
import ProgressBar from '@components/@core/ProgressBar';
import Toggle from '@components/@core/Toggle';
import { ProgramStatus } from '~/services/config';

const PdfIcon = loadable(() => import('~/views/Manage/Reports/CareerDetail/CareerDetailPdf'), {
    ssr: false,
});

const Detail = ({ state, program, requestable, current, contentLevel, onComplete, handlePdf }) => {
    const { data, stats, status } = program;
    const levels = data?.levels || [];
    const isCompleted = !isNil(levels[contentLevel]) && !isNil(levels[contentLevel].completed_at);
    const completedDate = isCompleted ? moment.utc(levels[contentLevel].completed_at).local().format('MMM DD, YY') : '';
    const levelStats = stats.levels ? stats.levels[current] : stats;
    const { courses, quotas } = levelStats;
    const isCourseCompleted = isNil(courses) ? true : courses.complete === courses.total;
    const isQuotaCompleted = isNil(quotas) ? true : quotas.complete === quotas.total;
    const isRequireCompleted = !isNil(levelStats) && isCourseCompleted && isQuotaCompleted;
    const totals = (isNil(quotas) ? 0 : quotas.total) + (isNil(courses) ? 0 : courses.total);
    const complete = (isNil(quotas) ? 0 : quotas.complete) + (isNil(courses) ? 0 : courses.complete);
    const totalProgress = totals === 0 ? 100 : ((complete * 100) / totals).toFixed(2);

    return (
        <div className="career-request mt-3">
            <div className="d-flex jc-between mb-3">
                <span className="dsl-b22 bold">{`Level ${contentLevel}`}</span>
                <div className="d-flex jc-end cursor-pointer ms-3">
                    <PdfIcon state={state} />
                </div>
            </div>
            <div className="d-flex ssm-column jc-between mb-0 ssm-b-0">
                <Input disabled className="input-field" title="Level Title" value={data.levels[contentLevel]?.title} />
                {!isCompleted && <ProgressBar className="level-progress" title="Progress" value={Number(totalProgress)} />}
            </div>
            <div className="d-flex jc-between">
                <Input disabled className="input-field" title="Est to Complete" value={`${data.estimated_days_to_complete} days`} />
                <div className="d-flex align-items-end justify-content-end">
                    {isCompleted ? (
                        <p className="dsl-b16">{`Completed ${completedDate}`}</p>
                    ) : (
                        requestable && !(status === ProgramStatus.PROMOTION) && <Button name="REQUEST COMPLETION" disabled={!isRequireCompleted || program.id === 0} onClick={onComplete} />
                    )}
                </div>
            </div>
            <Accordion className="settings pb-2" icon={null}>
                <Input disabled className="input-field" title="East Time to Complete" value={`${Number(data?.estimated_days_to_complete || 0).toFixed(0)} days`} />
                <Toggle
                    disabled
                    className="toggle-button mb-4"
                    title="Chronology Lock"
                    leftLabel="Off"
                    rightLabel="On"
                    direction="horizontal"
                    checked={data?.levels[contentLevel]?.chronology_lock || false}
                />
                <Toggle disabled className="toggle-button mb-4" title="Time Lock" leftLabel="Off" rightLabel="On" direction="horizontal" checked={data?.levels[contentLevel]?.time_lock || false} />
            </Accordion>
        </div>
    );
};

Detail.propTypes = {
    program: PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        stats: PropTypes.shape({
            levels: PropTypes.any,
        }),
        level: PropTypes.number,
        estimated_completion: PropTypes.string,
    }),
    current: PropTypes.number,
    requestable: PropTypes.bool,
    onComplete: PropTypes.func,
};

Detail.defaultProps = {
    program: {
        id: 0,
        title: '',
        stats: {
            levels: {},
        },
        level: 1,
        estimated_completion: '',
    },
    current: 1,
    requestable: false,
    onComplete: () => {},
};

export default memo(Detail);
